export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "帖子ID", prop: "tieba_ID" },
    { label: "评论内容", prop: "message" },
    // { label: "档案来源", prop: "source", slots: "source" },
    { label: "用户小程序openid", prop: "openid", },
    { label: "用户手机号", prop: "phone", slots: "phone", width: 160, },
    // { label: "档案", prop: "message", slots: "message", width: 160, },
    {
      label: "创建日期",
      prop: "createTime",
      width: 180,
    },
    // { label: "会话ID", prop: "answerNumber", slots: "answerNumber", width: 220, },
    {
      label: "操作",
      prop: "operation",
      width: 80,
      slots: "operation",
      fixed: "right",
    },
  ];
}
